/**
 * DashboardToolbar — slim control row above the chart secondary.
 *
 * V3 Page 01 — wraps the TimeWindowSelect (when DASHBOARD_TIME_WINDOW is
 * on) so the existing V2.5-B morning/afternoon/evening chips live inside
 * one cohesive control cluster and leave room for future toolbar
 * affordances (export, share, compare toggle).
 *
 * Purely presentational — all state comes from the parent Dashboard.
 */

import type { ReactNode } from 'react'

export interface DashboardToolbarProps {
  /** Slot for TimeWindowSelect / other controls. */
  children?: ReactNode
  /** Upper-case title on the left ("Revenue · hourly"). */
  title?: string
  'data-testid'?: string
}

export function DashboardToolbar({
  children,
  title = 'Revenue · hourly',
  ...rest
}: DashboardToolbarProps) {
  return (
    <div
      data-testid={rest['data-testid'] || 'dashboard-toolbar'}
      className="mt-5 flex flex-wrap items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-soft dark:text-slate-400"
      role="group"
      aria-label="Dashboard controls"
    >
      <span>{title}</span>
      <span className="text-hairline-strong">·</span>
      {children}
    </div>
  )
}
